import { MODE_WORDS } from "../../../agent";
import type { Mode } from "../../../api/types";

function count(value: number): string {
  return value.toLocaleString("en-US");
}

/**
 * The modes whose least context is more than the size typed. The server works out the least each mode needs (from the
 * largest situation of that mode); the screen only compares and says so in words.
 */
export function contextWarning(size: number, least: Record<string, number>): string | null {
  if (!Number.isFinite(size) || size <= 0) return null;
  const short = Object.entries(least)
    .filter(([, needed]) => size < needed)
    .sort(([, a], [, b]) => b - a)
    .map(([mode, needed]) => `${MODE_WORDS[mode as Mode] ?? mode} needs at least ${count(needed)}`);
  if (short.length === 0) return null;
  return `With a context size of ${count(size)}, some steps may not fit: ${short.join("; ")}. Raise the size, or choose a model with a larger context.`;
}

/** The least context any mode needs, for the hint under the box. */
export function leastOverall(least: Record<string, number>): number {
  const values = Object.values(least);
  return values.length ? Math.max(...values) : 0;
}
